import { gql } from '@apollo/client';

import { BRAND_COLORS_FRAGMENT, BRAND_IMAGES_FRAGMENT } from './fragments';

export const BRAND_IMAGES_MUTATION = gql`
  mutation BrandImagesMutation($id: String!, $update: UpdateBrandInput!) {
    brand: brand_update(id: $id, update: $update) {
      ...BrandImages
    }
  }
  ${BRAND_IMAGES_FRAGMENT}
`;

export const BRAND_COLORS_IMAGES_MUTATION = gql`
  mutation BrandColorsImagesMutation($id: String!, $update: UpdateBrandInput!) {
    brand: brand_update(id: $id, update: $update) {
      ...BrandColors
      ...BrandImages
    }
  }
  ${BRAND_COLORS_FRAGMENT}
  ${BRAND_IMAGES_FRAGMENT}
`;
